// config
import api from 'api';

const cancelTicket = async ({ id, feedBackDTO }) => {
  return await api.post(`price-negotiation/tickets/${id}/cancellations/`, {
    feedback: { ...feedBackDTO, stars: 0 },
  });
};

export default cancelTicket;
